import React from 'react';

import { filterEmptyContent, hasNoContent, getRichTextHeadingId } from '../utils';

import { StyledH2 } from './BlockH2Styles';

/**
 * Render h2 tag in rich text
 *
 * @param {React.ReactNode} children
 *
 * @returns {React.ReactElement}
 */
function BlockH2({ children }) {
  if (hasNoContent(children)) return null;

  return (
    <StyledH2 id={getRichTextHeadingId(children)} variant="DS_h3" component="h2">
      {filterEmptyContent(children)}
    </StyledH2>
  );
}

export default BlockH2;
